import Company from '../company/company';
import GenericModel from '../generic-model';
import { SignCompany } from './sign-company';

export class SignParticipatingCompany extends GenericModel {
  company: SignCompany;

  //Supports use of company picker component
  localCompany: Company;
}
